import { DeleteOutlined } from '@ant-design/icons';
import { Button } from '@mui/material';
import ConfirmationModal from 'components/modal/ConfirmationModal';
// import { useSnackbar } from 'notistack';
import { useState } from 'react';
import CamelCaseToWords from 'utils/helpers/CamelCaseToWords';

export const deleteWithAction = action => {
    return props => {
        const { component: MenuItem, onClick, params, ...restProps } = props;
        const { actionType, service } = action;
        const { id } = params;
        const entity = service.getModel();

        const title = CamelCaseToWords(entity.ModelFeatureAttribute.CLASS_NAME);

        let confirmationText = <>Are you sure you want to delete {title}?</>;

        const value = 'delete_with_action';
        const label = 'Delete';

        // const { enqueueSnackbar } = useSnackbar();

        const [openModal, setOpenModal] = useState(false);

        const handleOpenConfirmationModal = () => {
            setOpenModal(true);
        };

        const handleCloseConfirmationModal = () => {
            setOpenModal(false);
        };
        const handleDelete = async () => {
            try {
                await actionType(id);
                // enqueueSnackbar(title + ' was deleted', {
                //     variant: 'success',
                // });
                onClick(value);
                handleCloseConfirmationModal();
            } catch (err) {
                // const { error } = err;
                // if (error) {
                //     enqueueSnackbar(error, { variant: 'error' });
                // }
            }
        };

        return (
            <>
                <ConfirmationModal
                    onClose={handleCloseConfirmationModal}
                    isOpen={openModal}
                    title="Confirmation"
                    renderActions={() => (
                        <>
                            <Button
                                onClick={handleCloseConfirmationModal}
                                variant="outlined"
                                color="secondary"
                            >
                                Cancel
                            </Button>
                            <Button
                                onClick={handleDelete}
                                color="primary"
                                variant="contained"
                            >
                                Delete
                            </Button>
                        </>
                    )}
                >
                    {confirmationText}
                </ConfirmationModal>

                <MenuItem
                    key={value}
                    value={value}
                    label={label}
                    icon={<DeleteOutlined />}
                    onClick={handleOpenConfirmationModal}
                    {...restProps}
                >
                    {label}
                </MenuItem>
            </>
        );
    };
};
